import { TitleText } from 'text/part'
import { Article } from './types'

const ResearchArticle: Article = {
  title: TitleText.research,
  rows: {
    jp: [['インタラクティブに個人適応するスマートシステムの特徴づけ(LOIS202101)']],
    en: [["Characterizing Smart Systems with Interactive Personalization (LOIS202101)"]],
  },
}

export default ResearchArticle
